module.exports = __webpack_public_path__ + "img/one_.2c3d1aac.png";